export default [
  { path: '/news', 
    name: 'NewsList', 
    component: () => import('@/views/news/List'),
    meta: {
      breadcrumbs: [
        { text: 'ข่าวสาร', disabled: true }
      ]
    }
  },
  { 
    path: '/news/create', 
    name: 'NewsCreate', 
    component: () => import('@/views/news/Form'),
    meta: { 
      form_type: 'CREATE',
      form_title: 'สร้าง',
      breadcrumbs: [
        { text: 'ข่าวสาร', to: `/news` },
        { text: `สร้างข่าว` },
      ]
    }, 
  },
  { 
    path: '/news/:id/edit', 
    name: 'NewsEdit', 
    component: () => import('@/views/news/Form'),
    meta: { 
      form_type: 'EDIT',
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'ข่าวสาร', to: `/news` },
        { text: `แก้ไขข่าว` },
      ]
    }, 
  },
  { 
    path: '/news/:id/announcement', 
    name: 'NewsAnnouncement', 
    component: () => import('@/views/news/Form'),
    meta: { 
      form_type: 'ANNOUNCEMENT',
      form_title: 'ประกาศผล',
      breadcrumbs: [
        { text: 'ข่าวสาร', to: `/news` },
        { text: `ประกาศผล` },
      ]
    }, 
  },
];